import React, { useEffect, Fragment } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroSection from "../components/HeroSection";
import SectionContact from "../components/SectionContact";
import aboutImage from "../assets/images/aboutNew.webp";
import globalSteel from "../assets/images/GlobalSteel.webp";
import steelLegacy from "../assets/images/steelLegacy.webp";
import bgImage from "../assets/images/aboutUS.webp";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const AboutUs = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const navigate = useNavigate();
  const heroContent =
    "The essence of interior design will always be about us people and how they live. It is about the realities of what makes for an attractive, civilized.";
  return (
    <Fragment>
      <HeroSection
        title="About Us"
        backgroundImage={bgImage}
        content={heroContent}
      />
      <section className="about-section">
        <div className="about-container">
          <div
            className="about-content"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <h2>
              ABOUT{" "}
              <span className="highlight">
                Steel X Detailing and Engineering Services
              </span>
            </h2>
            <h3>
              We have established ourselves a trusted leader in market as a
              Steel Detailer.
            </h3>
            <p>
              Welcome to our website, where we take pride in delivering
              exceptional steel detailing services. As a trusted supplier, we
              prioritize strict adherence to steel fabricators’ standards,
              schedules, and unique requirements, ensuring top-notch quality in
              every project we undertake.
            </p>
          </div>
          <div
            className="about-image"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <img src={aboutImage} alt="Steel Detailing" />
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="about-container">
          {isMobile ? (
            <>
              <div
                className="about-content"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <h3>Excellent services to the worldwide detailing industry</h3>
                <p>
                  SteelX Detailing Services LLP is formed with the intention of
                  providing excellent services to the worldwide detailing
                  industry. We believe in Quality, Schedule & Good Communication
                  to build healthy customer relationships.
                </p>
                <ul>
                  <li>
                    Our dedication to client’s satisfaction gets proven by our
                    excellent service and timely delivery. Our motto is to
                    create an organization that provides complete customer
                    satisfaction
                  </li>
                  <li>
                    Our detailing team is capable of executing projects for all
                    types of steel structures as per AISC,CISC,BS,IS and various
                    other codes.
                  </li>
                  <li>
                    We have proven detailing experience in Industrial, Offshore,
                    Commercial & Residential Structures.
                  </li>
                </ul>
              </div>
              <div
                className="about-image"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <img src={globalSteel} alt="Steel Detailing" />
              </div>
            </>
          ) : (
            <>
              <div
                className="about-image"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <img src={globalSteel} alt="Steel Detailing" />
              </div>
              <div
                className="about-content"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h3>Excellent services to the worldwide detailing industry</h3>
                <p>
                  SteelX Detailing Services LLP is formed with the intention of
                  providing excellent services to the worldwide detailing
                  industry. We believe in Quality, Schedule & Good Communication
                  to build healthy customer relationships.
                </p>
                <ul>
                  <li>
                    Our dedication to client’s satisfaction gets proven by our
                    excellent service and timely delivery. Our motto is to
                    create an organization that provides complete customer
                    satisfaction
                  </li>
                  <li>
                    Our detailing team is capable of executing projects for all
                    types of steel structures as per AISC,CISC,BS,IS and various
                    other codes.
                  </li>
                  <li>
                    We have proven detailing experience in Industrial, Offshore,
                    Commercial & Residential Structures.
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
      </section>
      <section className="about-section">
        <div className="about-container">
          <div
            className="about-content"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <h3>Our Steel Legacy: Domestic and International Excellence</h3>
            <p>
              SteelX has participated in numerous domestic and international
              projects. These projects include hotels, malls, multi-story office
              buildings, schools and universities, hospitals. We have been
              successful in establishing ourselves as a quality supplier of
              steel detail drawings. We pride ourselves in strict adherence to
              each steel fabricator’s standard requirements, schedule and
              expectations.
            </p>
          </div>
          <div
            className="about-image"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <img src={steelLegacy} alt="Steel Detailing" />
          </div>
        </div>
      </section>
      <SectionContact />
    </Fragment>
  );
};

export default AboutUs;
